import { useEffect } from 'react';

const SignupPage = () => {
  useEffect(() => {
    window.location.href = '/app/signup';
  }, []);

  return null;
};

export default SignupPage;
